import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/boomingjobs.webp';
import screenshot_target from '../../../images/letterfunnel/marcelhageman.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Marcel Hageman"
      firstname="Marcel"
      companyname="Booming Jobs"
      competition="Jobboost.io en Wonderkind"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/marcelhageman.js